import React from "react";
import { SEO, MainLayout, PasswordSuccessfull } from "../../../components";

const PasswordSuccessfullPage = () => {
  return (
    <>
      <SEO title="password successfull" />
      <MainLayout>
        <PasswordSuccessfull />
      </MainLayout>
    </>
  );
};

export default PasswordSuccessfullPage;
